(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vf-custom-size"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root) => {
      if (root.dataset.vfReady) return;
      root.dataset.vfReady = '1';
      const formId = root.dataset.formId;
      const feeVariant = root.dataset.feeVariant;
      const panel = root.querySelector('[data-vf-fit-panel]');
      const fields = panel.querySelectorAll('input, textarea');
      const dialogs = Object.fromEntries([...root.querySelectorAll('[data-vf-dialog]')].map((d) => [d.dataset.vfDialog, d]));
      const note = root.querySelector('[data-vf-custom-note]');
      const noteText = root.querySelector('[data-vf-status-text]');
      const errorBox = root.querySelector('[data-vf-error]');
      const form = () => document.getElementById(formId);
      let measured = false;
      let pending = null;
      let resubmitting = false;

      const isCustom = () => root.querySelector('[data-vf-fit-toggle]:checked')?.value === 'custom';
      const express = () => !!root.querySelector('[data-vf-delivery][data-express]:checked');
      const open = (name) => dialogs[name]?.showModal();
      const sync = () => {
        const custom = isCustom();
        note.hidden = !custom;
        fields.forEach((el) => (el.disabled = !custom));
      };
      const missing = () => [...panel.querySelectorAll('[data-required]')].filter((el) => !el.value.trim());
      const markSaved = () => {
        note.classList.add('is-saved');
        noteText.innerHTML = '<strong>Measurements saved.</strong> They will be sent to our tailors with your order.';
        root.querySelector('[data-vf-open="measure"]').textContent = 'Edit measurements';
      };

      const addFee = async () => {
        if (!express() || !feeVariant) return;
        const cart = await fetch('/cart.js').then((r) => r.json());
        if (cart.items.some((i) => String(i.variant_id) === feeVariant)) return;
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(feeVariant), quantity: 1 }] }) });
      };

      const buyNow = async (btn) => {
        const f = form();
        if (!f) return;
        btn?.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            alert(err.description || 'Please choose your options and try again.');
            return;
          }
          await addFee();
          window.location.href = '/checkout';
        } finally {
          btn?.removeAttribute('aria-busy');
        }
      };

      root.querySelectorAll('[data-vf-fit-toggle]').forEach((r) => r.addEventListener('change', sync));
      root.querySelectorAll('[data-vf-open]').forEach((b) => b.addEventListener('click', () => { pending = null; open(b.dataset.vfOpen); }));
      root.querySelectorAll('[data-vf-close]').forEach((b) => b.addEventListener('click', () => b.closest('dialog').close()));
      Object.values(dialogs).forEach((d) => d.addEventListener('click', (e) => { if (e.target === d) d.close(); }));
      panel.querySelectorAll('[data-prop]').forEach((el) => el.addEventListener('input', () => {
        if (el.value.trim()) el.setAttribute('name', el.dataset.prop); else el.removeAttribute('name');
        el.closest('.vf-fit__field')?.classList.remove('is-missing');
      }));

      root.querySelector('[data-vf-save]').addEventListener('click', () => {
        const miss = missing();
        panel.querySelectorAll('.is-missing').forEach((x) => x.classList.remove('is-missing'));
        if (miss.length) {
          miss.forEach((el) => el.closest('.vf-fit__field')?.classList.add('is-missing'));
          errorBox.hidden = false;
          errorBox.textContent = `Please fill in the ${miss.length} required measurement${miss.length > 1 ? 's' : ''} marked in red.`;
          miss[0].closest('details')?.setAttribute('open', '');
          miss[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
          miss[0].focus({ preventScroll: true });
          return;
        }
        errorBox.hidden = true;
        measured = true;
        markSaved();
        dialogs.measure.close();
        const next = pending;
        pending = null;
        if (next === 'cart') form()?.requestSubmit();
        if (next === 'buy') buyNow(document.querySelector('[data-vf-buy-now]'));
      });

      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-vf-buy-now]');
        if (!btn || btn.dataset.formId !== formId) return;
        e.preventDefault();
        if (isCustom() && !measured) { pending = 'buy'; open('measure'); return; }
        buyNow(btn);
      });

      window.addEventListener('submit', async (event) => {
        const f = event.target;
        if (!(f instanceof HTMLFormElement) || f.getAttribute('id') !== formId || resubmitting) return;
        if (isCustom() && !measured) {
          event.preventDefault();
          event.stopImmediatePropagation();
          pending = 'cart';
          open('measure');
          return;
        }
        if (!express() || !feeVariant) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        try { await addFee(); } catch (e) {}
        resubmitting = true;
        f.requestSubmit(event.submitter || undefined);
        resubmitting = false;
      }, true);

      sync();
    };
    const run = () => document.querySelectorAll('[data-vf-fit]').forEach(init);
    run();
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

})();
